"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeFontShorthand = exports.openFontShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var shorthand_parser_errors_1 = require("../shorthand-parser-errors");
// TODO: Though not directly settable by font, the longhands font-size-adjust and font-kerning are also reset to their initial values.
// font
var openFontShorthand = function () {
    var fontPrefixShorthandParts = [
        { prop: 'font-style', dataType: css_data_types_1.fontStyleDataType, multipleItems: true },
        { prop: 'font-variant', dataType: css_data_types_1.fontVariantDataType },
        { prop: 'font-weight', dataType: css_data_types_1.fontWeightDataType },
        { prop: 'font-stretch', dataType: css_data_types_1.fontStretchDataType },
    ];
    var fontSizeShorthandPart = {
        prop: 'font-size',
        dataType: css_data_types_1.fontSizeDataType,
        mandatory: true,
    };
    var fontSuffixShorthandParts = [
        fontSizeShorthandPart,
        { prop: 'line-height', dataType: css_data_types_1.lineHeightDataType },
        {
            prop: 'font-family',
            dataType: css_data_types_1.fontFamilyDataType,
            multipleItems: true,
            mandatory: true,
        },
    ];
    var openFontShorthandPrefixInner = (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(fontPrefixShorthandParts, {
        commonValue: css_data_types_1.COMMON_FONT_PREFIX_NORMAL,
    });
    var openFontShorthandSuffixInner = (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(fontSuffixShorthandParts);
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'font',
        singleKeywordPart: { prop: 'font', dataType: css_data_types_1.fontSingleValueDataType },
        parts: fontPrefixShorthandParts.concat(fontSuffixShorthandParts),
        shorthandOpener: function (astNodes, api) {
            var opened = {};
            var prefixEndPart = fontSizeShorthandPart;
            var prefixEndIndex = -1;
            for (var i = 0; i < astNodes.length; i++) {
                if ((0, shorthand_parser_utils_1.matchDataType)(prefixEndPart.dataType, astNodes, i)) {
                    prefixEndIndex = i;
                    break;
                }
            }
            if (prefixEndIndex !== -1) {
                opened = tslib_1.__assign(tslib_1.__assign({}, openFontShorthandPrefixInner(astNodes.slice(0, prefixEndIndex), api)), openFontShorthandSuffixInner(astNodes.slice(prefixEndIndex), api));
            }
            else {
                throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('font', prefixEndPart.prop);
            }
            return opened;
        },
    });
};
exports.openFontShorthand = openFontShorthand;
var closeFontShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", " ", " ", " ", " / ", " ", ""], ["", " ", " ", " ", " ", " / ", " ", ""])), 'font-style', 'font-variant', 'font-weight', 'font-stretch', 'font-size', 'line-height', 'font-family'));
};
exports.closeFontShorthand = closeFontShorthand;
var templateObject_1;
//# sourceMappingURL=font-shorthand.js.map